import React from 'react';

interface State {
  error: Error | null;
}

interface Props {
  children: React.ReactNode;
}

export class ErrorBoundary extends React.Component<Props, State> {
  override state: State = { error: null };

  static getDerivedStateFromError(error: Error): State {
    return { error };
  }

  override componentDidCatch(error: Error, info: React.ErrorInfo): void {
    console.error('Render crash:', error, info);
  }

  reset = () => this.setState({ error: null });

  override render() {
    if (!this.state.error) return this.props.children;
    return (
      <main className="min-h-screen text-strong flex items-center justify-center p-6">
        <div className="max-w-md w-full surface rounded-2xl shadow p-8 space-y-4">
          <h1 className="text-xl font-semibold">Something broke</h1>
          <p className="text-sm text-mid">
            The app hit an unexpected error and stopped rendering. Reload the page to recover.
          </p>
          <pre className="text-xs surface-muted rounded p-3 overflow-auto max-h-40">
            {this.state.error.message}
          </pre>
          <div className="flex gap-2">
            <button
              type="button"
              onClick={() => window.location.reload()}
              className="btn-primary px-3 py-2 text-sm font-medium"
            >
              Reload
            </button>
            <button
              type="button"
              onClick={this.reset}
              className="rounded-lg border border-input bg-white px-3 py-2 text-sm font-medium hover:surface-muted"
            >
              Try again
            </button>
          </div>
        </div>
      </main>
    );
  }
}
